import React, { useEffect, useRef } from 'react';
export const ScrollToTarget = () => {
  const elementRef = useRef();
  useEffect(() => {
    if (elementRef.current) {
      const target = elementRef.current;
      target.scrollIntoView();
    }
  }, [elementRef.current]);
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef
  });
};